// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_O9Y","title":"styles_title__1CCTo"};